module.exports = __webpack_public_path__ + "img/logo.b7661a4c.svg";